import {
    postResetDetails,
    postResetRequest,
    postValidateCandidate,
} from '../api/CandidateRecoveryApi';

export const postResetPassword = (details,navigate) => async (dispatch) => {
    try {
        const result = await postResetDetails(details);
        if (result?.data?.status === 200) {
            let notify = { msg: result.data.message, theme: 'success' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            setTimeout(() => {
                navigate('/login');
            }, 2000);
            return;
        }
        if (result?.data?.error) {
            let notify = { msg: result.data.message, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
        if (result?.error) {
            let notify = { msg: result.error.message, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
    } catch (error) {
        return error;
    }
};
export const sendResetRequest = (details) => async (dispatch) => {
    try {
        const result = await postResetRequest(details);
        if (result?.data?.status === 200) {
            let notify = { msg: result.data.message, theme: 'success' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
        if (result?.data) {
            let notify = { msg: result.data.message, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
        if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
    } catch (error) {
        return error;
    }
};
export const verifyPasswordReset = (details) => async (dispatch) => {
    try {
        const result = await postValidateCandidate(details);
        if (result?.data?.success) {
            dispatch({ type: 'VERIFICATION_DETAILS', payload: result.data });
            return;
        }
        if (!result?.data?.success) {
            dispatch({ type: 'VERIFICATION_DETAILS', payload: result.data });
            return;
        }
        if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
            return;
        }
    } catch (error) {
        return error;
    }
};
